import { AxiosResponse } from 'axios';
import arrayBufferParse from '../arrayBufferParse';

export interface ReportResponseMessage {
  code?: string;
  description?: string;
  message?: string;
  timestamp?: string;
}

export class ReportResponseError extends Error {
  data?: ReportResponseMessage | null;
  status: number;

  constructor(status: number, data?: ReportResponseMessage | null) {
    super(
      data?.message ||
        data?.description ||
        'Arquivo ainda nao disponivel para download.',
    );

    this.data = data;
    this.name = 'ReportResponseError';
    this.status = status;
  }
}

export function parseReportResponse(
  response: AxiosResponse<ArrayBufferLike>,
): BlobPart {
  if (response.status === 200) {
    return response.data as BlobPart;
  }

  const data = arrayBufferParse<ReportResponseMessage>(response.data);

  throw new ReportResponseError(response.status, data);
}

export const fullReportResponseOptions = {
  returnFullResponse: true,
};
